import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Card, Button, Dropdown, Loader, Icon} from 'semantic-ui-react';
import {noTimeZoneShortISODate, dateFormatReservation} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';
import './setDetail.scss';

class SetsSalesDetailList extends Component {
  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.donwload = this.donwload.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.SetSales,
        scopes.See
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    this.props.changeSetSalesListDetailPageSize(20);
    this.props.changeSetSalesDetailListPage(0);
    this.onSearch();
  }

  onSearch() {
    const {startDateFilter, endDateFilter, customerId, setId} = this.props;
    this.props.deleteAccesoriesSetDetail();
    this.props.fetchAccesoriesSetsDetail({
      startDateFilter,
      endDateFilter,
      customerId,
      setId,
    });
  }

  donwload() {
    const {startDateFilter, endDateFilter, customerId, setId} = this.props;
    this.props.downloadSetSalesDetailFile({
      startDateFilter,
      endDateFilter},
    customerId,
    setId,
    );
  }

  onPageClick(value) {
    this.props.changeSetSalesDetailListPage(value);
  }

  changeStartDate(date) {
    const dateFormatted = date.format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }
    this.setState({'startDateFilter': dateFormatted});
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  onPageSizeClick(event, data) {
    this.props.changeSetSalesListDetailPageSize(data.value);
  }

  renderSetSalesDetail() {
    const {setSalesDetailList} = this.props;

    return setSalesDetailList.map((element, index) => {
      const dateshow = moment(element.created_date).format(
        dateFormatReservation
      );

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.customer_id}</Table.Cell>
          <Table.Cell textAlign='center'>{element.customer_name}</Table.Cell>
          <Table.Cell textAlign='center'> {dateshow}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.serie}
            {element.invoice_number}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.order}</Table.Cell>
          <Table.Cell textAlign='center'>{element.set_code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.chassis}</Table.Cell>
          <Table.Cell textAlign='center'>{element.part_code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.part_name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}
            {getNumericValue(element.price, 2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderSearchButton() {
    return (
      <Button primary className='toyota-primary' onClick={this.onSearch}>
        Consultar
      </Button>
    );
  }

  renderDownloadButton() {
    return (
      <Button
        primary
        className='toyota-primary download'
        onClick={this.donwload}
      >
        <Icon name='download' />
        Descargar
      </Button>
    );
  }

  renderLoad() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
  }

  renderPagination() {
    const {pageNumberDetail, pageSizeDetail, totalItems} = this.props;

    if (totalItems <= pageSizeDetail) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSizeDetail}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSizeDetail}
                selectedPage={pageNumberDetail}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <div className='setSales-detail'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>Consulta Ventas Accesorios</h2>
              <div className='title-bar-actions'>
                {this.renderDownloadButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Ruc</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cliente</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-row'>
                  Fecha Factura
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Número Factura
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Orden Trabajo
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Código Combo
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Chasis</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Artículo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Descripción Artículo
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Precio</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderSetSalesDetail()}
              {this.renderLoad()}
            </Table.Body>
            {this.renderPagination()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'setSalesDetailList': state.setsHeadSales.filteredDetailList,
    'totalItems': state.setsHeadSales.listDetail.length,
    'startDateFilter': ownProps.params.startDate,
    'endDateFilter': ownProps.params.endDate,
    'customerId': ownProps.params.customerId,
    'setId': ownProps.params.setCode,
    'pageNumberDetail': state.setsHeadSales.pageNumberDetail,
    'pageSizeDetail': state.setsHeadSales.pageSizeDetail,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {
  fetchAccesoriesSetsDetail,
  deleteAccesoriesSetDetail,
  downloadSetSalesDetailFile,
  changeSetSalesDetailListPage,
  changeSetSalesListDetailPageSize,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchAccesoriesSetsDetail,
  deleteAccesoriesSetDetail,
  downloadSetSalesDetailFile,
  changeSetSalesDetailListPage,
  changeSetSalesListDetailPageSize,
})(SetsSalesDetailList));
